export enum DisplayMode {
    LIST = 'list',
    GRID = 'grid',
    MAP = 'map'
}

export function createDisplayMode(display: string): DisplayMode {
    switch (display.toLowerCase()) {
        case 'list':
            return DisplayMode.LIST;

        case 'grid':
            return DisplayMode.GRID;

        case 'map':
            return DisplayMode.MAP;

        default:
            return DisplayMode.LIST;
    }
}

export const ALL_DISPLAY_MODES: DisplayMode[] = [DisplayMode.GRID, DisplayMode.LIST, DisplayMode.MAP];

export const RESULTS_PER_PAGE_OPTIONS: number[] = [10, 25, 50, 100];
